export const STATUS_LABELS = {
  pending_payment: "In attesa di pagamento",
  open: "Aperto",
  assigned: "Assegnato",
  in_progress: "In corso",
  completed: "Completato",
  closed: "Chiuso",
  cancelled: "Annullato",
};

export const VT_LABELS = { auto: "Auto", furgone: "Furgone", camion: "Camion" };

export const LEVEL_BADGES = {
  base: "text-slate-300 border-white/20",
  avanzato: "text-volt border-volt/40",
  premium: "text-spark border-spark/40",
};

const STATUS_COLORS = {
  pending_payment: "text-spark border-spark/30",
  open: "text-volt border-volt/30",
  assigned: "text-volt border-volt/30",
  in_progress: "text-amber-400 border-amber-400/30",
  completed: "text-emerald-400 border-emerald-400/30",
  closed: "text-slate-500 border-white/10",
  cancelled: "text-red-400 border-red-400/30",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`font-mono text-[10px] uppercase tracking-wider border rounded-full px-2.5 py-1 whitespace-nowrap ${STATUS_COLORS[status] || "text-slate-400 border-white/15"}`}
  >
    {STATUS_LABELS[status] || status}
  </span>
);

export const LevelBadge = ({ level, label }) => (
  <span
    data-testid={`level-badge-${level}`}
    className={`font-mono text-[10px] uppercase tracking-wider border rounded-full px-2.5 py-1 whitespace-nowrap ${LEVEL_BADGES[level] || "text-slate-400 border-white/15"}`}
  >
    {label || level}
  </span>
);
